import { FeaturesFilterValue } from './ColumnFilter'
import { ComparisonInterval } from './ComparisonInterval'

/**
 * Sentinel value for the updateTags url parameter marking that the user explicitly cleared
 * every version tag. Needed because query-string omits empty arrays, which would otherwise
 * be indistinguishable from an absent parameter (which defaults to Feature). (GR-1335)
 */
export const UPDATE_TAGS_NONE = 'none'

export type UpdateImpactSearchParams = {
  time?: string
  subgenres?: string | string[]
  updateTags?: string | string[]
  revenue?: (string | number | undefined)[]
  download?: (string | number | undefined)[]
  revDL?: (string | number | undefined)[]
  featureType?: FeaturesFilterValue
  features: string[]
  comparisonInterval?: ComparisonInterval
}
